import React from 'react';
import ListView from './ListView';
export default function Overlays(){
  return <ListView icon="overlays" title="Industry Overlays" subtitle="Industry-specific skill scoping (Healthcare, SaaS, Retail, etc.)." path="/overlays" columns={["id","key","name","included_credits"]} mapRow={r=>r} queryParam="key"/>;
}
